// ProductList.jsx
import React, { useMemo, useState, useEffect } from "react";
import Card from "../card/Card";
import Pagination from "../pagination/Pagination";

let PageSize = 12;

const ProductList = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Reset page to 1 whenever data changes
  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return data.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, data]);  // added data

  return (
    <div>
      <div className="flex justify-between my-3 bg-orange-100 border border-gray-100 rounded p-3">
        <h6 className="text-sm ">
          Total <span className="font-bold">{data.length}</span> items Found
        </h6>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-2 md:gap-3 lg:gap-3">
        {currentTableData.map((item) => {
          return <Card key={item.id || item.title} data={item} />;
        })}
      </div>
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={data.length}
        pageSize={PageSize}
        onPageChange={(page) => setCurrentPage(page)}
      />
    </div>
  );
};

export default ProductList;
